import { useQuery } from '@tanstack/react-query';

import { globalNotificationService } from '@/services/global_notification.service';

export const useGetAllGlobalNotifications = (pageNumber: number) => {
	const { data, isLoading, isError, error, refetch, isPending } = useQuery({
		queryKey: ['global-notification', pageNumber],
		queryFn: () =>
			globalNotificationService.getAllGlobalNotifications(pageNumber),
	});
	return {
		globalNotifications: data?.data ?? [],
		totalPages: data?.pageCount,
		isLoading,
		isError,
		error,
		refetch,
		isPending,
	};
};
